class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }    
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const currentContainer = document.getElementById('ProductGridContainer');
    const nextContainer = parsedHTML.getElementById('ProductGridContainer');

    if (!currentContainer || !nextContainer) return;

    currentContainer.innerHTML = nextContainer.innerHTML;
    CollectionAutoLoad.start();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => { 
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false; 
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    let searchParams = new URLSearchParams(formData).toString();
    if(jQuery('.main_collection_container').hasClass('filter-versions')){
      var $priceInput = $(".price-input input");
      var getminPrice = parseInt($priceInput.eq(0).val(), 10);
      var getmaxPrice = parseInt($priceInput.eq(1).val(), 10);
      if(defaultMin == getminPrice && defaultMax == getmaxPrice){
        // Build the clean query string
        let params = new URLSearchParams(searchParams);
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
        
        // Get the updated query string
        let cleanQuery = params.toString();

        searchParams = cleanQuery;
        setTimeout(function(){
          jQuery('#Mobile-Filter-Price-GTE').val(defaultMin);
          jQuery('#Mobile-Filter-Price-LTE').val(defaultMax);
        },1000);
      }
    }
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0]; 
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class CollectionAutoLoad {
  static start() {
    this.runId += 1;

    const currentRunId = this.runId;
    const loader = document.querySelector('[data-collection-auto-load]');
    const productGrid = document.getElementById('product-grid');

    if (!loader || !productGrid || !loader.dataset.nextUrl) {
      loader?.remove();
      return;
    }

    const spinner = loader.querySelector('.load-more-btn');

    if (spinner) {
      spinner.classList.add('loading');
    }

    this.loadAllPages(loader, productGrid, currentRunId);
  }

  static async loadAllPages(loader, productGrid, currentRunId) {
    let nextUrl = loader.dataset.nextUrl;
    const visitedUrls = new Set();

    try {
      while (nextUrl && currentRunId === this.runId) {
        const requestUrl = new URL(nextUrl, window.location.origin);

        if (productGrid.dataset.id) {
          requestUrl.searchParams.set('section_id', productGrid.dataset.id);
        }

        const requestKey = requestUrl.toString();

        if (visitedUrls.has(requestKey)) {
          throw new Error(`Repeated collection page URL: ${requestKey}`);
        }

        visitedUrls.add(requestKey);

        const response = await fetch(requestKey, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          throw new Error(`Unable to load products: ${response.status}`);
        }

        const responseText = await response.text();
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const nextProductGrid = parsedHTML.getElementById('product-grid');
        const nextLoader = parsedHTML.querySelector('[data-collection-auto-load]');

        if (!nextProductGrid) {
          throw new Error('The next product grid was not found.');
        }

        if (
          currentRunId !== this.runId ||
          document.getElementById('product-grid') !== productGrid
        ) {
          return;
        }

        const newProductItems = Array.from(nextProductGrid.children);

        newProductItems.forEach((item) => {
          productGrid.appendChild(item);
        });

        document.dispatchEvent(
          new CustomEvent('collection:products-appended', {
            detail: {
              items: newProductItems,
            },
          })
        );

        nextUrl = nextLoader?.dataset.nextUrl || '';

        if (nextUrl) {
          loader.dataset.nextUrl = nextUrl;
        }
      }

      if (currentRunId === this.runId && loader.isConnected) {
        loader.remove();
      }
    } catch (error) {
      if (currentRunId !== this.runId) return;

      console.error('Collection automatic loading error:', error);

      if (loader.isConnected) {
        loader.remove();
      }
    }
  }
}

CollectionAutoLoad.runId = 0;
CollectionAutoLoad.start();
